<template>
  <div class="p-6 text-center d-flex fd-column" :class="isOdd ? 'ODD': 'EVEN'">
    <div>
      <div class="h3 text-bold c-gray90 m-b-2">
        {{section.title}}
      </div>
      <div class="c-gray70">
        <div class="TEXT-DESCRIPTION p-r-2 p-r-4:d">
          <div class="p-b-4">{{section.description}}</div>
        </div>
        <div
            v-for="(testimonial, index) in this.section.testimonials"
            :key="index">
          <testimonial-item
              @content-error="$emit('content-error')"
              :testimonial="testimonial"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TestimonialItem from './TestimonialItem';

export default {
  name: 'testimonials-section',
  components: {
    TestimonialItem,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isOdd () {
      return this.index % 2 === 1;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.validateContent();
    });
  },
  methods: {
    validateContent () {
      const missingProperties = [
        'description',
        'title',
        'testimonials',
      ].filter(property => !Object.prototype.hasOwnProperty.call(this.section, property));
      if (Object.keys(this.section).length < 1) {
        this.$emit('content-error');
      }
      if (missingProperties.length > 0) {
        this.$emit('content-error');
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.TEXT-DESCRIPTION {
  text-align: center;
  font-size: 18px;
  margin: auto;
  @include desktop{
    width: 90 * $unit;
  }
}
.ODD {
  background-color: $color-gray20;
}
.EVEN {
  background-color: white;
}

</style>
